import React from 'react';

const IELTSStudyPage = ({ onBack, userPreferences }) => {
  const getText = (textObj) => {
    return textObj[userPreferences.displayLanguage] || textObj.traditional;
  };

  const texts = {
    title: {
      traditional: 'IELTS 學習',
      simplified: 'IELTS 学习',
      english: 'IELTS Study'
    },
    subtitle: {
      traditional: '國際英語語言測試系統',
      simplified: '国际英语语言测试系统',
      english: 'International English Language Testing System'
    },
    description: {
      traditional: '專為IELTS考試設計的完整學習課程，涵蓋聽、說、讀、寫四個技能。',
      simplified: '专为IELTS考试设计的完整学习课程，涵盖听、说、读、写四个技能。',
      english: 'Complete learning course designed for IELTS exam, covering all four skills: listening, speaking, reading, and writing.'
    },
    back: {
      traditional: '返回',
      simplified: '返回',
      english: 'Back'
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 text-white">
      {/* Header */}
      <div className="flex items-center justify-between p-6">
        <button
          onClick={onBack}
          className="text-blue-400 hover:text-blue-300 transition-colors"
        >
          ← {getText(texts.back)}
        </button>
        <h1 className="text-xl font-bold">{getText(texts.title)}</h1>
        <div className="w-8"></div>
      </div>

      {/* Content */}
      <div className="px-6">
        <div className="bg-gray-800/30 rounded-xl p-6 mb-6">
          <h2 className="text-2xl font-bold mb-2">{getText(texts.subtitle)}</h2>
          <p className="text-gray-300 mb-4">{getText(texts.description)}</p>
          
          {/* Placeholder content */}
          <div className="grid grid-cols-2 gap-4">
            <div className="bg-gray-700/50 rounded-lg p-4">
              <h3 className="font-semibold mb-2">👂 聽力</h3>
              <p className="text-gray-300 text-sm">學術與日常對話聽力訓練</p>
            </div>
            
            <div className="bg-gray-700/50 rounded-lg p-4">
              <h3 className="font-semibold mb-2">🗣️ 口說</h3>
              <p className="text-gray-300 text-sm">個人陳述與雙向討論練習</p>
            </div>
            
            <div className="bg-gray-700/50 rounded-lg p-4">
              <h3 className="font-semibold mb-2">📖 閱讀</h3>
              <p className="text-gray-300 text-sm">學術文章閱讀理解技巧</p>
            </div>
            
            <div className="bg-gray-700/50 rounded-lg p-4">
              <h3 className="font-semibold mb-2">✍️ 寫作</h3>
              <p className="text-gray-300 text-sm">圖表描述與議論文寫作</p>
            </div>
          </div>
        </div>

        {/* Progress Section */}
        <div className="bg-gray-800/30 rounded-xl p-6 mb-6">
          <h3 className="text-lg font-semibold mb-4">📊 學習進度</h3>
          <div className="space-y-3">
            <div className="flex justify-between items-center">
              <span className="text-gray-300">聽力</span>
              <div className="flex items-center space-x-2">
                <div className="w-24 bg-gray-600 rounded-full h-2">
                  <div className="bg-green-500 h-2 rounded-full" style={{ width: '65%' }}></div>
                </div>
                <span className="text-sm text-gray-300">65%</span>
              </div>
            </div>
            <div className="flex justify-between items-center">
              <span className="text-gray-300">口說</span>
              <div className="flex items-center space-x-2">
                <div className="w-24 bg-gray-600 rounded-full h-2">
                  <div className="bg-blue-500 h-2 rounded-full" style={{ width: '45%' }}></div>
                </div>
                <span className="text-sm text-gray-300">45%</span>
              </div>
            </div>
            <div className="flex justify-between items-center">
              <span className="text-gray-300">閱讀</span>
              <div className="flex items-center space-x-2">
                <div className="w-24 bg-gray-600 rounded-full h-2">
                  <div className="bg-yellow-500 h-2 rounded-full" style={{ width: '78%' }}></div>
                </div>
                <span className="text-sm text-gray-300">78%</span>
              </div>
            </div>
            <div className="flex justify-between items-center">
              <span className="text-gray-300">寫作</span>
              <div className="flex items-center space-x-2">
                <div className="w-24 bg-gray-600 rounded-full h-2">
                  <div className="bg-purple-500 h-2 rounded-full" style={{ width: '32%' }}></div>
                </div>
                <span className="text-sm text-gray-300">32%</span>
              </div>
            </div>
          </div>
        </div>

        {/* Coming Soon Notice */}
        <div className="text-center py-8">
          <div className="bg-blue-500/20 border border-blue-500/50 rounded-lg p-6">
            <h3 className="text-lg font-semibold mb-2">🚧 開發中</h3>
            <p className="text-gray-300">
              {userPreferences.displayLanguage === 'traditional' ? '此功能正在開發中，敬請期待！' :
               userPreferences.displayLanguage === 'simplified' ? '此功能正在开发中，敬请期待！' :
               'This feature is under development. Stay tuned!'}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IELTSStudyPage;
